import React, {useContext} from 'react';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';
import PrivacyPolicyDe from './de/PrivacyPolicyDe';
import MarketingCookieInfoDe from './de/MarketingCookieInfoDe';
import MarketingCookieInfoEn from './en/MarketingCookieInfoEn';

export function MarketingCookieInfo(props) {
    const locale = useContext(LocaleContext);

    return (
        <div>
            <div className="flex_col">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <MarketingCookieInfoDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <MarketingCookieInfoEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>
        </div>
    );
}
